<template>
  <v-container>
    <div 
      v-if="status === 'loading'" 
      style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; z-index: 995; background-color: transparent;"
    >
      <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
    </div>

    <v-row class="d-flex justify-center mx-auto">
      <v-col cols="12" xs="12" sm="11" md="10" lg="9">
        <v-card class="white--text mx-auto my-auto mt-12" persistent width="95%" height="400" flat>
          <v-card-title primary-title>
            <div class="mb-2">
              <div class="text-h5 primary2--text text--darken-3">Regístrate</div>
              <span class="subtitle-1 secundary--text">¿Ya tienes una cuenta?</span>
              <router-link :to="{ name: 'patLogin' }" style="text-decoration: none; color: inherit">
                <span class="subtitle-1 primary--text ml-2">Iniciar sesión</span>
              </router-link>
            </div>
          </v-card-title>
          <v-card-text class="mt-5">
            <v-form width="70%" ref="myForm">
              <v-form-base
                id="form-base-complete"
                v-if="schemaForm && modelForm"
                :schema="schemaForm"
                :model="modelForm"
                @input="log"
                @click="log"
              />
              <v-row class="mt-8 mx-0 px-0">
                <v-checkbox
                  v-model="checkbox"
                  @change="handleEventsbox"
                  hide-details
                  class="d-flex justify-end align-start mr-0 pr-0 mt-0 pt-0"
                ></v-checkbox>
                <v-col cols="11" class="ml-0 pl-0 mt-0 pt-0">
                  <a class="text-caption black--text">Acepto los&nbsp;</a>
                  <router-link
                    :to="{ name: 'homePatLegal' }"
                    style="text-decoration: none; color: inherit"
                  >
                    <a class="text-caption primary--text">Términos y condiciones,&nbsp;</a>
                  </router-link>
                  <a class="text-caption black--text"
                    >y autorizo el uso de mis datos de acuerdo a la&nbsp;</a
                  >
                  <router-link
                    :to="{ name: 'homePatLegal' }"
                    style="text-decoration: none; color: inherit"
                  >
                    <a class="text-caption primary--text">Políticas de privacidad.</a>
                  </router-link>
                </v-col>
              </v-row>
              <v-btn class="secundary2 white--text ml-1 mt-3 text-capitalize" @click="save">
                Registrarse
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import VFormBase from 'vuetify-form-base';

export default {
  name: 'PatSignUp',
  components: {
    VFormBase,
  },

  props: ['schemaForm', 'modelForm', 'save', 'checkboxTerms', 'handleEventsbox', 'status'],

  data() {
    return {
      checkbox: false,
    };
  },

  methods: {
    update(checkboxTerms) {
      this.checkbox = checkboxTerms;
    },

    log(val) {
      let { on, key, obj, params } = val;
      if (
        on === 'click' &&
        key === 'subgroups.content' &&
        (params && params.tag) === 'prepend-inner'
      ) {
        window.print();
      }
      if (on === 'click' && key === 'password' && (params && params.tag) === 'append') {
        obj.schema.type === 'password'
          ? (obj.schema.appendIcon = 'mdi-eye-off')
          : (obj.schema.appendIcon = 'mdi-eye');
        obj.schema.type = obj.schema.type === 'password' ? 'text' : 'password';
      }
    },
  },
};
</script>
